import { Component, OnInit, Input, forwardRef, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => FileInputComponent),
	multi: true
}

@Component({
	selector: 'app-file-input',
	templateUrl: './file-input.component.html',
	styleUrls: ['./file-input.component.scss'],
	providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
})

export class FileInputComponent implements OnInit {

	files: any
	output: any
	@Input() allowdirectory: boolean = false;
	@ViewChild('inputfile') inputfile: ElementRef;

	constructor() { }

	ngOnInit() {
	}

	private onTouchedCallback: () => void = noop;
	private onChangeCallback: (_: any) => void = noop;

	//get accessor
	get value(): any {
		return this.files;
	}

	//set accessor including call the onchange callback
	set value(v: any) {
		if (v !== this.output) {
			this.files = v;
			this.onChangeCallback(v);
		}
	}

	delete() {
		this.value = []
	}

	select() {
		this.inputfile.nativeElement.click()
	}

	//From ControlValueAccessor interface
	writeValue(value: any) {
		if (value !== this.files) {
			this.files = value;
		}
	}

	//From ControlValueAccessor interface
	registerOnChange(fn: any) {
		this.onChangeCallback = fn;
	}

	//From ControlValueAccessor interface
	registerOnTouched(fn: any) {
		this.onTouchedCallback = fn;
	}

}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/file-input/file-input.component.ts